import { createSlice } from '@reduxjs/toolkit';
import { getLayoutDataThunk, saveLayoutDataThunk } from './GridActions';

export interface GridData {
  loading: boolean;
  configData: any;
}

const initialState: GridData = {
  loading: false,
  configData: {},
};

const gridDataSlice = createSlice({
  name: 'Grid Layout Data',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLayoutDataThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLayoutDataThunk.fulfilled, (state, action) => {
        if (action.payload[0]?.screenId) {
          state.configData[action.payload[0].screenId] = action.payload;
        }
        state.loading = false;
      })
      .addCase(getLayoutDataThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveLayoutDataThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveLayoutDataThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(saveLayoutDataThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

// export const {  } = gridDataSlice.actions;
export default gridDataSlice.reducer;
